import { render } from "./columns.vue?vue&type=template&id=62ff9671"
import script from "./columns.vue?vue&type=script&lang=js"
export * from "./columns.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./columns.vue?vue&type=style&index=0&id=62ff9671&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__